const TEMPLATE_NAME = 'PAD_DASHBOARD';

const initialState = () => ({
  loading: false,
  data: {
    pad: null,
    patient: null,
    visits: null,
    prescription: null
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        data
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
